/** Splits a drop into files to upload, names already present (in the scope or earlier in this drop) and files failing the size check */
export function partitionDroppedFiles(
  acceptedFiles: File[],
  existingNames: Array<string | null | undefined>,
  isFileSizeValid: (size: number) => boolean = () => true
) {
  const seen = new Set(existingNames.filter((name): name is string => !!name))
  const okFiles: File[] = []
  const duplicateFileNames: string[] = []
  const sizeRejectedNames: string[] = []

  for (const file of acceptedFiles) {
    if (seen.has(file.name)) {
      duplicateFileNames.push(file.name)
      continue
    }
    // Added only once the file survives the size check — a rejected file that kept its name would
    // make the next file of that name report as "already uploaded" instead of as too large
    if (!isFileSizeValid(file.size)) {
      sizeRejectedNames.push(file.name)
      continue
    }

    seen.add(file.name)

    okFiles.push(file)
  }

  return { okFiles, duplicateFileNames, sizeRejectedNames }
}
